import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { MeasurementToolService } from '@connect-services/client/services/measurement-tool.service';
import { ButtonComponent, ButtonType } from '@connect-services/src/lib/components/button/button.component';
import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ButtonComponent, RessourcesModule],
    selector: 'app-map-modal-measurement',
    templateUrl: './map-modal-measurement.component.html',
})
export class MapModalMeasurementComponent {
    protected readonly ButtonType = ButtonType;
    protected readonly measurementToolService = inject(MeasurementToolService);
}
